import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Text, Currency} from 'components/UIKit';
import styles from '../ListingExpenses.scss';
import {ListingExpense as ListingExpenseType} from '../../../types';
import * as locales from '../locales';

export interface ListingExpenseProps {
  expense: ListingExpenseType;
}

function ListingExpenseComponent({i18n, expense}: ListingExpenseProps & WithI18nProps) {
  const {title, value, perTimePeriod} = expense;
  const showTimePeriod = perTimePeriod !== undefined;
  return (
    <li key={title} className={styles.ListItem}>
      <dl className={styles.Expense}>
        <dt>
          <Text secondary text={title} />
        </dt>
        <dd className={styles.Amount}>
          <Currency inline showDecimal={value % 1 !== 0} value={value} />
          {showTimePeriod && <Text secondary text={`/${i18n.translate(perTimePeriod)}`} />}
        </dd>
      </dl>
    </li>
  );
}

export const ListingExpense = withI18n({
  id: 'ListingExpenses',
  fallback: locales.en,
})(ListingExpenseComponent);

export default ListingExpense;
